import React from 'react';
import * as PropTypes from 'prop-types';
import _ from 'lodash';

import { Step } from './step';

import './steps.scss';

export class Steps extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      current: this.getCurrentStep(props.current),
    };

    this.getCurrentStep = this.getCurrentStep.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.current !== this.props.current) {
      this.setState({
        current: this.getCurrentStep(nextProps.current),
      });
    }
  }

  getCurrentStep(step) {
    const { steps } = this.props;
    let currentStep;
    if (step > steps.length - 1) {
      currentStep = steps.length - 1;
    } else if (step < 0) {
      currentStep = 0;
    } else {
      currentStep = step;
    }
    return currentStep;
  }

  render() {
    const { steps } = this.props;
    const { current } = this.state;
    return (
      <nav className="steps" steps={steps.length}>
        {_.map(steps, (step, i) => {
          const active = current === i;
          return <Step label={step} index={i + 1} isCurrent={active} key={`step-${i}`} />;
        })}
      </nav>
    );
  }
}

Steps.propTypes = {
  steps: PropTypes.array.isRequired,
  current: PropTypes.number,
};

Steps.defaultProps = {
  current: 0,
};

export default Steps;
